import * as Factory from 'factory.ts'
import faker from 'faker'

import { CurrencyNames } from '@webapp/core/entities/external/Currency'
import { type FinancialAccountBalanceSummaryApiModel } from '../FinancialAccountBalanceSummaryApiModel'

export const FinancialAccountBalanceSummaryApiModelStub =
  Factory.Sync.makeFactory<FinancialAccountBalanceSummaryApiModel>({
    balance: Factory.each(() => faker.finance.amount()),
    allocated_spending_card_funds: Factory.each(() => faker.finance.amount()),
    upcoming_bill_payments: Factory.each(() => faker.finance.amount()),
    total_allocated_funds: Factory.each(() => faker.finance.amount()),
    available_funds: Factory.each(() => faker.finance.amount()),
    currency: CurrencyNames.USD,
    has_insufficient_funds_for_payment: false,
  })
